<template>
  <div class="notification__wrapper">
    <slot></slot>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.component("NotificationLayout", {});
</script>

<style lang="scss" scoped>
$ns: "notification";

.#{$ns}__wrapper {
  height: 100%;
  background: #e5e5e5;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;
}

@media only screen and (max-width: 600px) {
  .#{$ns}__wrapper {
    background: $white;
  }
}
</style>
